import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'privacy-statement',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.less'],
})
export class PrivacyStatementComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
